import { FC } from 'react';

import * as Styles from './styles';

interface ITrending {
  value: number;
}

export const Trending: FC<ITrending> = ({ value }) => {
  const trendingUp = value > 0;
  const parsedValue = value.toFixed(2);
  return (
    <Styles.Container css={{ color: trendingUp ? '$colors$green' : '$colors$red' }}>
      {trendingUp ? <i>trending_up</i> : <i>trending_down</i>}
      {parsedValue}%
    </Styles.Container>
  );
};
